module.exports = __webpack_public_path__ + "static/media/videojs-icon.bf6e57d4.svg";